<h3>Macnica Tracks</h3>

<div class="tw-mb-8">
  @if (apikey.hasApikey) {
    <div class="tw-mb-2">API Key（Client ID／Client Secret）作成済み</div>
    <button
      id="cancel-btn"
      mat-raised-button
      type="button"
      (click)="deleted.emit()"
    >
      <mat-icon>close</mat-icon>
      <span>API Key（Client ID／Client Secret）破棄</span>
    </button>
  } @else {
    <button
      mat-raised-button
      id="search-btn"
      class="tw-text-lg tw-mx-2"
      color="primary"
      (click)="created.emit()"
    >
      <span>API Key（Client ID／Client Secret）発行</span>
    </button>
  }
</div>

<div class="tw-flex tw-mb-2">
  <h3 class="tw-flex tw-items-center">
    Webhook
    <mat-icon
      [matTooltip]="tooltipMessage"
      matTooltipClass="tw-whitespace-pre-line matp-large-tooltip"
      class="tw-ml-1"
    >
      info
    </mat-icon>
  </h3>
</div>
<form [formGroup]="formGroup" class="tw-mb-3 tw-mx-2">
  <div class="tw-flex tw-flex-col tw-gap-y-6 tw-w-full">
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      [ngClass]="{ 'matp-form-field-readonly': !updating }"
      class="!tw-h-14"
    >
      <mat-label>URL</mat-label>
      <input
        matInput
        formControlName="webhookUrl"
        name="webhookUrl"
        [required]="updating"
        [readonly]="!updating"
      />
      <mat-error
        *ngIf="updating && formGroup.controls.webhookUrl.errors?.['required']"
      >
        URLを入力してください。
      </mat-error>
      <mat-error
        *ngIf="updating && formGroup.controls.webhookUrl.errors?.['pattern']"
      >
        https://から始まる文字列を入力してください。
      </mat-error>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      [ngClass]="{ 'matp-form-field-readonly': !updating }"
      class="!tw-h-14"
    >
      <mat-label>API Key Header名</mat-label>
      <input
        matInput
        formControlName="keyHeaderName"
        name="keyHeaderName"
        [required]="updating"
        [readonly]="!updating"
      />

      <mat-error
        *ngIf="
          updating && formGroup.controls.keyHeaderName.errors?.['required']
        "
      >
        API Key Header名を入力してください。
      </mat-error>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      [ngClass]="{ 'matp-form-field-readonly': !updating }"
      class="!tw-h-14"
    >
      <mat-label>API Key 値</mat-label>
      <input
        matInput
        class="masked-input"
        [class.show]="showPassword"
        formControlName="apiKeyValue"
        name="apiKeyValue"
        [required]="updating"
        [readonly]="!updating"
        [type]="'text'"
      />
      @if (updating) {
        <button
          id="toggle-pass-btn"
          matSuffix
          mat-icon-button
          (click)="togglePasswordVisibility()"
        >
          <mat-icon>{{
            showPassword ? "visibility_off" : "visibility"
          }}</mat-icon>
        </button>
      }

      <mat-error
        *ngIf="updating && formGroup.controls.apiKeyValue.errors?.['required']"
      >
        API Key 値を入力してください。
      </mat-error>
    </mat-form-field>
  </div>

  <div class="tw-mt-6">
    @if (!updating) {
      <button
        mat-raised-button
        id="edit-mode-btn"
        color="primary"
        type="button"
        class="tw-w-28 tw-mr-2"
        (click)="updating = !updating"
      >
        <mat-icon>edit</mat-icon>
        <span>編集</span>
      </button>
      <button
        mat-stroked-button
        id="delele-btn"
        color="warn"
        type="submit"
        class="tw-w-28"
        (click)="deletedWebhook()"
        [disabled]="formGroup.invalid"
      >
        <mat-icon>delete</mat-icon>
        <span>削除</span>
      </button>
    } @else {
      <button
        mat-raised-button
        color="white"
        class="tw-w-40 tw-mr-2"
        (click)="cancelEditing()"
      >
        <mat-icon>close</mat-icon>
        <span>キャンセル</span>
      </button>
      <button
        mat-raised-button
        id="edit-btn"
        color="accent"
        type="submit"
        class="tw-w-48"
        (click)="updatedWebhook()"
        [disabled]="formGroup.invalid"
      >
        <mat-icon>done</mat-icon>
        <span>編集内容保存</span>
      </button>
    }
  </div>
</form>
